module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"joinUs":"Join us <br> on our social networks!"},"fr":{"joinUs":"Rejoignez nous <br> sur nos réseaux sociaux !"}}')
  delete Component.options._Ctor
}
